class ApiError extends Error {
    constructor(statusCode,message,response) {
        super(message);
        this.statusCode = statusCode;
        this.response = response;
    }
}

export default ApiError;